<template>
  <v-card class="mx-auto" width="300" tile>
    <v-navigation-drawer v-model="toggle" app>
      <v-list-item class="blue darken-2">
        <v-list-item-content class="text-center">
          <v-list-item-title class="title-menu">Menu</v-list-item-title>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list>

        <v-list-item @click="menu('home')">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>

        <span v-for="(item, index) in menuGral" :key="index">
          <v-list-item v-if="!item.group" :class="item.hidden" @click="menu(item.action)">
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item>

          <v-list-group v-else no-action :class="item.hidden" >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="(i, index) in item.items" :key="index" link dense :class="i.hidden" @click="menu(i.action)">
              <v-list-item-subtitle dense>{{i.title}}</v-list-item-subtitle>
              <v-list-item-icon>
                <v-icon>{{i.icon}}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

        </span>

        <v-divider></v-divider>

        <v-list-item @click="menu('logout')">
          <v-list-item-action>
            <v-icon class="blanco">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="blanco">Cerrar Sesion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
export default {
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    user: {},
    menuGral: [
      {
        id: 'person.get',
        action: 'ViewPersonas',
        icon: 'mdi-home',
        title: 'Personas',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'menu.adm',
        group: true,
        title: 'Administracion',
        hidden: 'hiddenItem',
        items: [
          {
            id: 'usr.list',
            action: 'ViewUsers',
            icon: 'mdi-home',
            title: 'Usuarios',
            hidden: 'hiddenItem'
          },
          {
            id: 'rol.list',
            action: 'ViewRoles',
            icon: 'mdi-account-network',
            title: 'Roles',
            hidden: 'hiddenItem'
          },
          {
            id: 'perm.list',
            action: 'ViewPermisos',
            icon: 'mdi-key',
            title: 'Permisos',
            hidden: 'hiddenItem'
          }
        ]
      },
      {
        id: 'menu.cat',
        group: true,
        title: 'Catalogos',
        hidden: 'hiddenItem',
        items: [
          {
            id: 'mun.get',
            action: 'ViewMunicipios',
            icon: 'mdi-home',
            title: 'Municipios',
            hidden: 'hiddenItem'
          },
          {
            id: 'distr.get',
            action: 'ViewDistritos',
            icon: 'mdi-calendar',
            title: 'Distritos',
            hidden: 'hiddenItem'
          },
          {
            id: 'secc.get',
            action: 'ViewSecciones',
            icon: 'mdi-calendar',
            title: 'Secciones',
            hidden: 'hiddenItem'
          },
          {
            id: 'survey.show',
            action: 'ViewEncuestas',
            icon: 'mdi-calendar-text',
            title: 'Encuestas',
            hidden: 'hiddenItem'
          },
          {
            id: 'period.show',
            action: 'ViewPeridos',
            icon: 'mdi-calendar-text',
            title: 'Periodos',
            hidden: 'hiddenItem'
          }

        ]
      }
    ]
  }),
  mounted () {
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')))
  },
  methods: {
    ...mapActions(['getUrlServices', 'getUrlServiceLogoutAction']),
    menu (item) {
      if (item === 'logout') {
        this.$swal.fire({
          title: '¿Desea cerrar su sesion ?',
          text: 'Asegurese de haber concluido sus labores diarias',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Cerrar sesion',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.value) {
            this.getUrl('usr.logout')
          }
        })
      } else {
        router.push({ name: item }).catch(() => {})
      }
    },
    PermisosMenu (user) {
      if (user.descripcion) {
        if (user.descripcion.special === 'all-access') {
          this.menuGral.map(action => {
            if (action.group) {
              action.hidden = ''
              action.items.map(subItems => {
                subItems.hidden = ''
              })
            } else {
              action.hidden = ''
            }
          })
        } else {
          this.menuGral.map(action => {
            user.permisos.map(item => {
              if (action.group) {
                if (item.slug === action.id) {
                  action.hidden = ''
                  action.items.map(subItems => {
                    user.permisos.map(per => {
                      if (per.slug === subItems.id) {
                        subItems.hidden = ''
                      }
                    })
                  })
                }
                // action para los sub menu
              } else {
                if (item.slug === action.id) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.menuGral.map(action => {
          user.permisos.map(item => {
            if (action.group) {
              if (item.slug === action.id) {
                action.hidden = ''
                action.items.map(subItems => {
                  user.permisos.map(per => {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                    }
                  })
                })
              }
            // action para los sub menu
            } else {
              if (item.slug === action.id) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServiceLogoutAction(router)
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_logout'])
  },
  watch: {
    get_logout (val) {
      if (val) {
        if (val.result) {
          this.$cookies.remove('token')
          localStorage.removeItem('permisos')
          localStorage.removeItem('user')
          router.push('/')
        }
      }
    }
  }
}
</script>

<style>
.relleno {
  color: white;
  background: #bf360c;
}
.title-menu {
  color: white;
  font-size: 20px !important;
  max-width: 100% !important;
  height: 38px !important;
  text-align: center !important;
}
.hiddenItem{
  display: none;
}
</style>
